function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M43.813 41.959H3.04A2.027 2.027 0 011 39.943V28.86c0-1.113.913-2.015 2.039-2.015h40.774c1.126 0 2.039.902 2.039 2.015v11.084a2.027 2.027 0 01-2.039 2.016z",
  fill: "url(#pin-illustration_svg__paint0_linear_62_1899)"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.9 30.364c.374 0 .685.27.75.625l.012.137-.001 2.214 1.952-1.112a.761.761 0 01.867 1.245l-.113.079-1.93 1.1 1.93 1.103a.762.762 0 01-.63 1.38l-.124-.056-1.952-1.114v2.215a.762.762 0 01-1.51.137l-.012-.137-.002-2.215-1.95 1.114a.761.761 0 01-.867-1.246l.113-.078 1.93-1.102-1.93-1.101a.762.762 0 01.63-1.381l.124.057 1.95 1.112.002-2.214c0-.42.34-.762.761-.762z",
  fill: "url(#pin-illustration_svg__paint1_linear_62_1899)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.584 30.364c.374 0 .685.27.75.625l.012.137-.002 2.216 1.953-1.114a.761.761 0 01.867 1.245l-.113.079-1.93 1.1 1.93 1.103a.762.762 0 01-.63 1.38l-.124-.056-1.953-1.116.002 2.217a.762.762 0 01-1.511.137l-.012-.137v-2.215l-1.952 1.114a.761.761 0 01-.867-1.246l.113-.078 1.93-1.102-1.93-1.101a.762.762 0 01.63-1.381l.124.057 1.952 1.112v-2.214c0-.42.34-.762.761-.762z",
  fill: "url(#pin-illustration_svg__paint2_linear_62_1899)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.268 30.364c.374 0 .685.27.749.625l.012.137v2.216l1.951-1.114a.761.761 0 01.868 1.245l-.113.079-1.931 1.1 1.931 1.103a.762.762 0 01-.63 1.38l-.125-.056-1.952-1.116.001 2.217a.762.762 0 01-1.51.137l-.013-.137v-2.215l-1.95 1.114a.761.761 0 01-.868-1.246l.113-.078 1.93-1.102-1.93-1.101a.762.762 0 01.63-1.381l.124.057 1.951 1.112v-2.214c0-.42.341-.762.762-.762z",
  fill: "url(#pin-illustration_svg__paint3_linear_62_1899)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.952 30.364c.374 0 .685.27.75.625l.011.137-.001 2.216 1.953-1.114a.761.761 0 01.867 1.245l-.113.079-1.931 1.1 1.931 1.103a.762.762 0 01-.63 1.38l-.124-.056-1.953-1.116.001 2.217a.762.762 0 01-1.51.137l-.013-.137v-2.215l-1.95 1.114a.761.761 0 01-.868-1.246l.113-.078 1.93-1.102-1.93-1.101a.762.762 0 01.63-1.381l.124.057 1.95 1.112.001-2.214c0-.42.341-.762.762-.762z",
  fill: "url(#pin-illustration_svg__paint4_linear_62_1899)"
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 36.509,
  cy: 16.613,
  rx: 10.736,
  ry: 10.613,
  fill: "#F6694C"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.882 14.34a.97.97 0 00.976-.965c0-.336.37-.621 1.045-.621.67 0 .907.23.907 1.056 0 .42-.253.783-.95 1.393-.038.033-.135.118-.22.19l-.133.116c-.147.129-.26.231-.367.334-.571.551-.887 1.067-.887 1.735v.643a.97.97 0 00.976.965.97.97 0 00.976-.965v-.643c0-.02.07-.133.3-.355a7.718 7.718 0 01.413-.37l.237-.206c1.083-.948 1.607-1.7 1.607-2.837 0-1.9-1.117-2.986-2.859-2.986-1.661 0-2.997 1.03-2.997 2.551a.97.97 0 00.976.965zm1.301 8.384c.719 0 1.301-.576 1.301-1.287 0-.71-.582-1.286-1.3-1.286-.72 0-1.302.576-1.302 1.286 0 .711.583 1.287 1.301 1.287z",
  fill: "#fff"
});

var _ref8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "pin-illustration_svg__paint0_linear_62_1899",
  x1: -1.805,
  y1: 36.35,
  x2: 4.471,
  y2: 55.513,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEB31A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE852A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "pin-illustration_svg__paint1_linear_62_1899",
  x1: 5.272,
  y1: 35.926,
  x2: 10.727,
  y2: 41.083,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF8C6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD98A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "pin-illustration_svg__paint2_linear_62_1899",
  x1: 14.956,
  y1: 35.926,
  x2: 20.411,
  y2: 41.083,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF8C6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD98A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "pin-illustration_svg__paint3_linear_62_1899",
  x1: 24.64,
  y1: 35.926,
  x2: 30.095,
  y2: 41.083,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF8C6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD98A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "pin-illustration_svg__paint4_linear_62_1899",
  x1: 34.324,
  y1: 35.926,
  x2: 39.779,
  y2: 41.083,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF8C6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD98A"
})));

function SvgPinIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

export default SvgPinIllustration;